import { SxProps, Theme } from '@mui/material';

export const NotificationsModalFrameSX = (isMobile: boolean): SxProps<Theme> => ({
	position: 'absolute',
	top: isMobile ? undefined : '50%',
	left: isMobile ? 0 : '50%',
	bottom: isMobile ? 0 : undefined,
	transform: isMobile ? undefined : 'translate(-50%, -50%)',
	width: isMobile ? '100%' : 'auto',
	minWidth: isMobile ? '100%' : '300px',
	maxWidth: isMobile ? '100%' : '500px',
	maxHeight: '80vh',
	bgcolor: 'background.paper',
	boxShadow: 2,
	borderRadius: '6px',
	borderBottomLeftRadius: isMobile ? 0 : '6px',
	borderBottomRightRadius: isMobile ? 0 : '6px',
	overflowY: 'auto',
});

export const NotificationsModalHeaderFrameSX = (isMobile: boolean): SxProps<Theme> => ({
	display: 'flex',
	justifyContent: 'flex-end',
	padding: isMobile ? '8px 5px 0px 0px' : '10px 10px 0px 10px',
});

export const NotificationsModalHeaderIconSX: SxProps<Theme> = {
	cursor: 'pointer',
};

export const NotificationsModalContentSX = (isMobile: boolean): SxProps<Theme> => ({
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	alignItems: 'center',
	padding: isMobile ? '0px 25px 30px 25px' : '0px 60px 30px 60px',
});

export const NotificationsModalTitleSX =
	(isMobile: boolean): SxProps<Theme> =>
	(theme) => ({
		fontSize: theme.typography.pxToRem(isMobile ? 20 : 24),
		fontWeight: 800,
		textAlign: 'center',
		marginBottom: '10px',
	});

export const NotificationsModalMessageSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-body)',
	textAlign: 'center',
	marginBottom: '20px',
	whiteSpace: 'pre-line',
};

export const NotificationsModalButtonSX: SxProps<Theme> = {
	width: '100%',
};
